import { Type } from 'class-transformer'
import { IsDate, IsNotEmpty } from 'class-validator'

export class UpdatedEventSiteDTO {
  siteId: string
  eventId: string
}

export class UpdatedEventSitesSearchDTO {
  @IsNotEmpty()
  @IsDate()
  @Type(() => Date)
  since: Date
}
